import * as React from 'react'
import { LucideIcon } from 'utils/lucideIcon'
import { GLOBAL_SEARCH_STATE_EVENT, OPEN_GLOBAL_SEARCH_EVENT } from './hooks/useGlobalSearchOverlay'
import './globalSearchTrigger.scss'
import { useTranslation } from 'translations'

export function GlobalSearchTrigger(): JSX.Element {
    const { t } = useTranslation()
    const isMac = typeof navigator !== 'undefined' && /mac/i.test(navigator.platform)

    // Pressed while the search overlay is open, released when it closes.
    const [isPressed, setIsPressed] = React.useState(false)
    React.useEffect(() => {
        const onStateChange = (event: Event) => {
            setIsPressed(Boolean((event as CustomEvent<{ open: boolean }>).detail?.open))
        }
        window.addEventListener(GLOBAL_SEARCH_STATE_EVENT, onStateChange)
        return () => window.removeEventListener(GLOBAL_SEARCH_STATE_EVENT, onStateChange)
    }, [])

    return (
        <button
            type="button"
            className={`global-search-trigger${isPressed ? ' is-pressed' : ''}`}
            aria-expanded={isPressed}
            onClick={() => window.dispatchEvent(new CustomEvent(OPEN_GLOBAL_SEARCH_EVENT))}
            aria-label={t('globalSearch.trigger.ariaLabel', { modifier: isMac ? 'Cmd' : 'Ctrl' })}
        >
            <div className="global-search-trigger-icon">
                <LucideIcon iconName="Search" size={13} strokeWidth={2} />
            </div>
            <span className="global-search-trigger-text">{t('common.search')}</span>
            <div className="global-search-trigger-kbd">
                <kbd>{isMac ? '⌘' : 'Ctrl'}</kbd>
                <kbd>K</kbd>
            </div>
        </button>
    )
}
